import { useState, useEffect, useRef } from 'react';

export function useScrollFAB() {
    const [fabVisible, setFabVisible] = useState(true);
    const lastScrollYRef = useRef(0);

    // UI-002: FAB auto-hide on scroll — hides when scrolling down, shows when scrolling up
    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollYRef.current && currentScrollY > 100) {
                setFabVisible(false);
            } else {
                setFabVisible(true);
            }
            lastScrollYRef.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return { fabVisible };
}
